<template>
    <div :key="$route.fullPath">
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white" style="min-height:65vh; display: flex; flex-direction: column;">
            <br /><br /><br />
            <CCol sm="12" style="width: 80%; background-size: cover; margin: auto; color: #fff">
                <br /><br /><br />
                <CRow>
                    <CCol sm="8" style="background-size: cover; margin: auto; color: #fff">
                        <CRow class="p-20 m-3" style="display: block;justify-content: center;">
                            <div class="text-center mt-5">
                                <img src="../assets/img/Spinner-3.gif" />
                                <h3 class="font-color-171717 mt-3">Processing...</h3>
                            </div>
                        </CRow>
                        <br /><br />
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundGenie,
            isActive: false,

            packages: [],
            details: {},
            refNo: this.$route.query.refNo,
            amount: 0,
            hasSubmitted: false,
        };
    },
    mounted() {
     
        setTimeout(() => {
            this.SubmitData();
        }, 10000); 
      
    },

    methods: {
        SubmitData() {
            console.log("SubmitData() called with:", this.$route.query);

            const formData = new FormData();
            formData.append("userId", this.$route.query.userId);
            formData.append("billplzid", this.$route.query.billplzId);

            return this.$API
                .post(this.$UpdatePaymentPackage, formData)
                .then((response) => {
                    console.log("API Response:", response);
                    if (response.status == 200 && response.data != null) {
                        // 🔥 Only set sessionStorage on successful response
                        sessionStorage.setItem("hasSubmitted", "true");

                        this.$router.push({
                            path: "SuccessReceipt",
                            query: this.$route.query,
                        });
                    }
                })
                .catch((error) => {
                    console.error("API Error:", error);
                    this.Error = true;
                    this.Message = "Error processing payment.";
                });
        }
    }

};
</script>
  
<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}
</style>
  